import { localized } from "@hr/common/utils.jsx";
import { SelectOption } from "@hr/common/types.ts";

export const useGetFormsOfSalaryOptions = (): SelectOption<number>[] => {
  const salaryForms: { [key: number]: string } = localized?.salaryForms;

  return Object.entries(salaryForms)
    .slice(1, 3)
    .map(([key, value]) => ({
      value: parseInt(key, 10),
      label: value,
    }));
};
